const arrowPushSVG = `
<svg width="250px" height="69px" viewBox="0 0 250 69" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->
    <title>arrowPush</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-push">
            <stop stop-color="#DADADA" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#4C59A6" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-454.000000, -820.000000)">
        <polygon id="arrowPush" fill="url(#linearGradient-push)" points="454 820 681.724175 820 704 854.5 681.724175 889 454 889"></polygon>
    </g>
</svg>
`;

export default arrowPushSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/arrowPushSVG.js